import { activeConditionsQuery } from '../planner/context';
import type { ProtocolSpec } from '../planner/plan';
import { asthmaOngoingMeasurements, copdOngoingMeasurements } from './respiratoryOngoingMeasurements';

/**
 * The COPD ongoing-measurement protocol, ready for `planProtocol`. No variables: every action is
 * unconditional, so nothing needs deriving — but `activeConditionsQuery` is still listed, because
 * topic matching reads the patient's Conditions to find the topic this protocol belongs on.
 */
export const copdOngoingMeasurementsProtocol: ProtocolSpec = {
  planDefinition: copdOngoingMeasurements,
  valueSets: [],
  queries: [activeConditionsQuery],
  deriveVariables: () => ({}),
};

/** The asthma ongoing-measurement protocol, ready for `planProtocol`. */
export const asthmaOngoingMeasurementsProtocol: ProtocolSpec = {
  planDefinition: asthmaOngoingMeasurements,
  valueSets: [],
  queries: [activeConditionsQuery],
  deriveVariables: () => ({}),
};
